// Vendors
import $ from 'jquery';
import { AJAX_URL } from './config';

const applySignupDiscount = localStorage.getItem(
  'apply-signup-and-save-discount'
);

// Apply Discount
if (applySignupDiscount !== null) {
  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}try_to_apply_signup_coupon`,
    dataType: 'json',
    encode: true,
    success: (res) => {
      if (res.data.message === 'Signup Discount Applied') {
        // Remove Cookie
        localStorage.removeItem('apply-signup-and-save-discount');
      }
    }
  });
}

$(document).on('click', 'button.plus, button.minus', function () {
  // Get current quantity values
  const qty = $(this).parent().find('.qty');
  const val = parseFloat(qty.val());
  const max = parseFloat(qty.attr('max'));
  const min = parseFloat(qty.attr('min'));
  const step = parseFloat(qty.attr('step'));

  // Change the value if plus or minus
  if ($(this).is('.plus')) {
    if (max && max <= val) {
      qty.val(max);
      qty.trigger('change');
    } else {
      qty.val(val + step);
      qty.trigger('change');
    }
  } else {
    if (min && min >= val) {
      qty.val(min);
    } else if (val > 1) {
      qty.val(val - step);
      qty.trigger('change');
    }
  }
});

$('.woocommerce').on('change', 'input.qty', function () {
  $("[name='update_cart']").prop('disabled', false);
  $("[name='update_cart']").trigger('click');
});

const updateFreeShippingNotice = () => {
  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}post_update_free_shipping_notice_partial`,
    dataType: 'json',
    encode: true,
    success: (res) => {
      if (res.data) {
        $('.free-shipping-notice').html(res.data);
      }
    }
  });
};

const updateNavCartTotalIcon = () => {
  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}post_get_cart_quantity`,
    dataType: 'json',
    encode: true,
    success: (res) => {
      if (res.data) {
        $('.cart-quantity').html(res.data);
      }
    }
  });
};

// Look for Cart Updates
$(document).on('updated_cart_totals', function () {
  updateFreeShippingNotice();
  updateNavCartTotalIcon();

  if ($('.woocommerce-message').text().indexOf('Cart updated') > -1) {
    $('.woocommerce-message').hide();
  }
});
